import { Button, Form, type FormInstance } from 'antd';
import { setStoredInput } from 'presentation/redux/features/CU/CU03101Slice';
import { useAppDispatch, useAppSelector } from 'presentation/redux/hooks';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import React from 'react';
import { useNavigate, useParams } from 'react-router';
import getMessage from 'utilities/constants/MESSAGE';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { ListedPropertyRoomGetAssessmentDetail } from '../../CU-033-01/models/Property';
import { CountStep } from './CountStep';
import { InputNumberWithFraction, InputText, InputWholeNumber } from './Input';
import UploadImage from './Upload';

interface props {
    form: FormInstance;
    detailAssessment?: ListedPropertyRoomGetAssessmentDetail;
}

export const StepOne = ({ form, detailAssessment }: props) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const storedInput = useAppSelector((state) => state.CU03101Slice.storedInput);
    const disabledBTN = useAppSelector((state) => state.CU03101Slice.disabledBTN);
    const { propertyId } = useParams();

    const backToPreviousStep = () => {
        navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_030_01}/${propertyId}`);
    };

    const onNext = () => {
        const newStoredInput = {
            ...storedInput,
            roomNumber: form.getFieldValue('roomNumber'),
            occupiedFloor: form.getFieldValue('occupiedFloor'),
            occupiedArea: form.getFieldValue('occupiedArea'),
            balconyArea: form.getFieldValue('balconyArea'),
            image: form.getFieldValue('image'),
            isEdit: form.getFieldValue('isEdit') ? form.getFieldValue('isEdit') + '' : null,
            page: 1,
            prev: false,
            submit: true,
        };
        if (form.getFieldValue('image')) {
            newStoredInput.roomLayoutDiv = '';
            newStoredInput.bathToiletSeparatedDiv = '';
            newStoredInput.indoorLaundryRoomDiv = '';
            newStoredInput.notes = '';
        }
        dispatch(setStoredInput(newStoredInput));
    };
    return (
        <React.Fragment>
            <CountStep current={1} title="部屋情報を入力してください。" />
            <InputText
                label="部屋番号"
                name="roomNumber"
                isRequired
                addonAfter="号室"
                placeholder={PLACEHOLDER.ROOM_NUMBER}
                requiredMessage={getMessage('In_Required', '部屋番号')}
                maxLength={5}
            />
            <InputWholeNumber
                label="専有部分所在階"
                name="occupiedFloor"
                isRequired
                addonAfter="階"
                placeholder={PLACEHOLDER.OCCUPIED_FLOOR}
                requiredMessage={getMessage('In_Required', '専有部分所在階')}
                max={999}
            />
            <InputNumberWithFraction
                label="専有面積"
                name="occupiedArea"
                labelClassName="content-form label-form"
                isRequired
                addonAfter="m²"
                placeholder={PLACEHOLDER.OCCUPIED_AREA}
                requiredMessage={getMessage('In_Required', '専有面積')}
                max={999.99}
            />
            <InputNumberWithFraction
                label="バルコニー面積（任意）"
                labelClassName="content-form label-form"
                name="balconyArea"
                isRequired={false}
                addonAfter="m²"
                placeholder={PLACEHOLDER.BALCONY_AREA}
                max={999.99}
            />
            <UploadImage
                form={form}
                existedFile={storedInput?.image}
                initialImageUrl={detailAssessment?.propertyImages[0]?.imageFilePath ?? undefined}
                imageId={detailAssessment?.propertyImages[0]?.id}
            />
            <section
                style={{
                    width: '100%',
                    justifyContent: 'space-between',
                    display: 'flex',
                }}
            >
                <Button
                    className="button-login-text"
                    style={{
                        width: 165.5,
                        height: 56,
                        marginTop: 16,
                        color: '#28323C',
                    }}
                    onClick={backToPreviousStep}
                >
                    戻る
                </Button>
                <Form.Item>
                    <Button
                        type="primary"
                        className="button-login-text"
                        style={{ width: 165.5, height: 56, marginTop: 16 }}
                        onClick={() => onNext()}
                        htmlType="submit"
                    >
                        次へ
                    </Button>
                </Form.Item>
            </section>
        </React.Fragment>
    );
};
